<template>
  <q-page class="flex-center">
    <div class="q-pa-md">
      <q-table
        title="Doadores"
        :data="campangns.data"
        :columns="columns"
        row-key="id"
        :visible-columns="visibleColumns"
        :loading="$apollo.loading"
        :pagination.sync="pagination"

      >
        <template v-slot:top="props">
          <div class="row col-12 q-col-gutter-xs">
            <div class="col-11 text-center text-h3">Campanhas</div>
            <div class="col-1 text-center">
              <q-btn color="bg-purple-10" outline icon="add" @click="$router.push({name:'campangn-new'})" ></q-btn>
            </div>
          </div>
         <!-- <div class="row col-12">
          &lt;!&ndash;  <div class="col-6 ">
              <q-input outlined style="border: 1px solid white;" dense input-class="inputSearch" debounce="300"
                       @input="mudaInput" v-model="filter"
                       placeholder="Buscar">
                <template v-slot:append>
                  <q-icon name="search"/>
                </template>
              </q-input>

            </div>&ndash;&gt;

          </div>-->
        </template>
        <template v-slot:header="props">
          <q-tr :props="props" >
            <q-th auto-width />
            <q-th
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
              :style="col.style"
            >
              {{ col.label }}
            </q-th>

          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props">
            <!-- Botao de mais -->
            <q-td auto-width>
              <q-btn size="sm" color="accent" round  @click="props.expand = !props.expand" :icon="props.expand ? 'remove' : 'add'" />
            </q-td>

            <!-- corpo da tabela -->

            <q-td key="id" :props="props">
              <a :href="getLink(props)" target="_blank">
                {{props.row.id}}
              </a>
              </q-td>
            <q-td key="name" :props="props">{{ props.row.name }}</q-td>
            <q-td key="saldo" :props="props">R$ {{ props.row.saldo }}</q-td>
            <q-td key="total_sum" :props="props">R$ {{ props.row.total_sum }}</q-td>
            <q-td key="created_at" :props="props">{{ formataData(props.row.created_at) }}</q-td>
            <q-td key="started_at" :props="props">{{ formataData(props.row.started_at) }}</q-td>
            <q-td key="finished_at" :props="props">
              {{ formataData(props.row.finished_at) }}
              <q-popup-edit v-model="props.row.finished_at" buttons @save="salvaPopup(props.row.finished_at, props.row.id)"  label-set="Registrar">
                <q-input outlined mask="##/##/####" v-model="props.row.finished_at"
                          label="Data de término">

                  <template v-slot:append>
                    <q-icon name="event" class="cursor-pointer">
                      <q-popup-proxy ref="qDateProxy">
                        <q-date v-model="props.row.finished_at" mask="DD/MM/YYYY" @input="()=>  $refs.qDateProxy.hide()"/>
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                </q-input>
              </q-popup-edit>
            </q-td>
            <q-td key="options" :props="props">
             <!-- <q-btn color="primary" icon="create"
                     @click="$router.push({name:'campangn-edit',params: {id: props.row.id}})"></q-btn>-->
            </q-td>
            <!--<q-td
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.value }}
            </q-td>-->
          </q-tr>
          <q-tr v-show="props.expand" :props="props">
            <q-td colspan="100%">
              <q-table
                title="Doadores"
                :data="props.row.donations"
                :columns="secondary_columns"
                row-key="id"
              >
                <!--:pagination="pagination_secondary"-->
              </q-table>
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
    <q-inner-loading :showing="loading">
      <q-spinner-dots size="50px" color="primary"/>
    </q-inner-loading>
  </q-page>
</template>

<script>
// @request="onRequest"
import { CAMPANGNS, FINISH_CAMPANGN } from '../graphql/graphql'
import { DateTime } from 'luxon'
import numeraljs from 'numeraljs'

export default {
  name: 'Campangn',
  apollo: {
    campangns: {
      query: CAMPANGNS,
      variables () {
        return {
          page: this.pagination.page,
          count: this.pagination.rowsPerPage,
          orderBy: [{ field: 'name', order: 'ASC' }]
        }
      },
      skip: true
      // pollInterval: 300, // ms
    }
  },
  methods: {
    formataData (val) {
      return val ? DateTime.fromSQL(val, { locale: 'pt-br' }).toLocaleString(DateTime.DATE_SHORT) : null
    },
    mudaInput () {

    },
    getLink (value) {
      return `https://${value.row.slug}.crm.cancer.org.br`
    },
    salvaPopup (finished_at, id) {
      this.loading = true
      this.$apollo.mutate({
        mutation: FINISH_CAMPANGN,
        variables: {
          finished_at: finished_at,
          id: id
        },
        update: (store, data) => {
          if (data.data.finishCampangn.id) {
            this.loading = false
            alert('Informação cadastrada com sucesso!')
          }
        }
      })
    }
  },
  computed: {
    host () {
      // return process.env.VUE_APP_GHOST + '/email-register/'
    }
  },
  data () {
    return {
      loading: false,
      campangn: {},
      filter: '',
      finished_at: '',
      visibleColumns: [
        'id',
        'name',
        'saldo',
        'total_sum',
        'started_at',
        'created_at',
        'finished_at',
        'options'
      ],
      columns: [
        {
          name: 'id',

          label: 'ID',
          field: 'id',

          align: 'left',
          style: 'width: 200px !important'
        }, {
          name: 'name',

          label: 'Nome',
          align: 'left',
          style: '',
          field: 'name'
        }, {
          name: 'saldo',

          label: 'Arrecadado',
          align: 'left',
          field: 'saldo',
          style: '',
          format: val => 'R$ ' + numeraljs(val).format('0,00')
        }, {
          name: 'total_sum',

          label: 'Esperado',
          align: 'left',
          field: 'total_sum',
          style: '',
          format: val => 'R$ ' + numeraljs(val).format('0,00')
        }, {
          name: 'started_at',

          label: 'Início',
          align: 'left',
          field: 'started_at',
          style: '',
          headerClasses: 'bg-primary text-white',
          format: val => {
            if (val) return DateTime.fromSQL(val, { locale: 'pt-br' }).toLocaleString(DateTime.DATE_SHORT)
          }

        }, {
          name: 'created_at',

          label: 'Registro',
          align: 'left',
          field: 'created_at',
          style: '',
          headerClasses: 'bg-primary text-white',
          format: val => {
            if (val) return DateTime.fromSQL(val, { locale: 'pt-br' }).toLocaleString(DateTime.DATE_SHORT)
          }

        }, {
          name: 'finished_at',

          label: 'Término',
          align: 'left',
          field: 'finished_at',
          style: '',
          headerClasses: 'bg-primary text-white',
          format: val => {
            if (val) return DateTime.fromSQL(val, { locale: 'pt-br' }).toLocaleString(DateTime.DATE_SHORT)
          }

        }, {
          name: 'options',

          label: 'Opções',
          align: 'left',
          field: 'options',
          style: '',
          headerClasses: 'bg-primary text-white'

        }
      ],
      secondary_columns: [
        {
          name: 'id',

          label: 'ID da doação',
          field: 'id'
        }, {
          name: 'amount',

          label: 'Valor',
          align: 'left',
          field: 'amount',
          format: val => 'R$ ' + numeraljs(val).format('0,00')
        }, {
          name: 'maturity_date',

          label: 'Vencimento',
          align: 'left',
          field: 'maturity_date',

          format: val => {
            if (val) return DateTime.fromSQL(val, { locale: 'pt-br' }).toLocaleString()
          }
        }, {
          name: 'payment_date',

          label: 'Pagamento',
          align: 'left',
          field: 'payment_date',

          format: val => {
            if (val) return DateTime.fromSQL(val, { locale: 'pt-br' }).toLocaleString()
          }
        }, {
          name: 'our_number',

          label: 'Nosso número',
          align: 'left',
          field: 'our_number'
        }, {
          name: 'payment_formr',

          label: 'Forma de pagamento',
          align: 'left',
          field: 'payment_form',
          format: val => val ? val.name : ''
        }, {
          name: 'donator.id',

          label: 'ID do doador',
          align: 'left',
          field: 'donator',
          format: val => val ? val.id : ''
        }, {
          name: 'donator.full_name',

          label: 'Nome do doador',
          align: 'left',
          field: 'donator',
          format: val => val ? val.full_name : ''
        }, {
          name: 'donator.document',

          label: 'Document do doador',
          align: 'left',
          field: 'donator',
          format: val => val ? val.document : ''
        }, {
          name: 'donator.email',

          label: 'Email do doador',
          align: 'left',
          field: 'donator',
          format: val => val ? val.email : ''
        }, {
          name: 'donator.tel_res',

          label: 'Telefone fixo do doador',
          align: 'left',
          field: 'donator',
          format: val => val ? val.tel_res : ''
        }, {
          name: 'donator.tel_cel',

          label: 'Telefone celular do doador',
          align: 'left',
          field: 'donator',
          format: val => val ? val.tel_cel : ''
        }, {
          name: 'donator.created_at',

          label: 'Cadastro do doador',
          align: 'left',
          field: 'donator',

          format: val => {
            if (val) {
              return DateTime.fromSQL(val.created_at, { locale: 'pt-br' }).toLocaleString()
            }
          }
        }
      ],
      pagination: {
        sortBy: 'name',
        descending: false,
        page: 1,
        rowsPerPage: 50,
        rowsNumber: 50
      },
      pagination_secondary: {
        sortBy: 'name',
        descending: false,
        page: 1,
        rowsPerPage: 50,
        rowsNumber: 50
      }
    }
  },
  mounted () {
    this.$apollo.queries.campangns.skip = false
    this.$apollo.queries.campangns.refetch().then(result => this.pagination.rowsNumber = result.data.campangn.paginatorInfo.total)
  }
}
</script>

<style scoped>

</style>
